<template>
    <div class="lite_popup add_drive" v-show="auth.show && !hidePopup">
        <div class="lite_popup_box">
            <div class="lite_popup_title">
                <span>{{ auth.did ? $t('language.leftBanner.edit') : $t('language.common.addCloud') }}</span>
                <div class="icon white-close dialog-close" @click="auth.show = false"></div>
            </div>
            <div class="lite_popup_content">
                <el-form :model="auth" label-width="110px">
                    <!-- 一般云盘 -->
                    <el-form-item :label="$t('language.common.type')" style="display:none;">
                        <el-input v-model="auth.type" disabled></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('language.popup.addCloudPopup.cloudName')">
                        <el-input v-model="auth.name"></el-input>
                    </el-form-item>
                    <!-- FTP -->
                    <div v-if="auth.type == 'FTP'">
                        <el-form-item :label="$t('language.popup.addCloudPopup.protocol')">
                            <el-select v-model="auth.ftp.protocol">
                                <el-option label="ftp-plain" value="ftp-plain"></el-option>
                                <el-option label="ftps-explicit" value="ftps-explicit"></el-option>
                                <el-option label="ftps-implicit" value="ftps-implicit"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.server')">
                            <el-input v-model="auth.ftp.host"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.port')">
                            <el-input v-model="auth.ftp.port"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                            <el-input v-model="auth.ftp.username"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passWord')">
                            <el-input v-model="auth.ftp.password"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passive')">
                            <div class="switch-box">
                                <el-switch v-model="auth.ftp.passive" active-color="#5166BD"></el-switch>
                            </div>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.encoding')">
                            <el-select v-model="auth.ftp.encoding">
                                <el-option label="ISO-8859-1" value="ISO-8859-1"></el-option>
                                <el-option label="UTF-8" value="UTF-8"></el-option>
                                <el-option label="GBK" value="GBK"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.path')">
                            <el-input v-model="auth.ftp.path"></el-input>
                        </el-form-item>
                    </div>
                    <!-- SFTP -->
                    <div v-if="auth.type == 'SFTP'">
                        <el-form-item :label="$t('language.popup.addCloudPopup.server')">
                            <el-input v-model="auth.sftp.host"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.port')">
                            <el-input v-model="auth.sftp.port"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                            <el-input v-model="auth.sftp.username"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passWord')">
                            <el-input v-model="auth.sftp.password"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.privateKey')">
                            <el-input v-model="auth.sftp.privateKey" type="textarea"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passphrase')">
                            <el-input v-model="auth.sftp.passphrase"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.path')">
                            <el-input v-model="auth.sftp.path"></el-input>
                        </el-form-item>
                    </div>
                    <!-- WebDAV -->
                    <div v-if="auth.type == 'WebDAV'">
                        <el-form-item :label="$t('language.popup.addCloudPopup.server')">
                            <el-input v-model="auth.webdav.url"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                            <el-input v-model="auth.webdav.username"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passWord')">
                            <el-input v-model="auth.webdav.password"></el-input>
                        </el-form-item>
                    </div>
                    <!-- MySQL -->
                    <div v-if="auth.type == 'MySQL'">
                        <el-form-item :label="$t('language.popup.addCloudPopup.server')">
                            <el-input v-model="auth.mysql.host"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.port')">
                            <el-input v-model="auth.mysql.port"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                            <el-input v-model="auth.mysql.username"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passWord')">
                            <el-input v-model="auth.mysql.password"></el-input>
                        </el-form-item>
                    </div>
                    <!-- Backblaze -->
                    <div v-if="auth.type == 'Backblaze'">
                        <el-form-item :label="$t('language.popup.addCloudPopup.keyID')">
                            <el-input v-model="auth.backblaze.applicationKeyId"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.applicationKey')">
                            <el-input v-model="auth.backblaze.applicationKey"></el-input>
                        </el-form-item>
                    </div>
                    <!-- MediaFire -->
                    <div v-if="auth.type == 'MediaFire'">
                        <el-form-item :label="$t('language.popup.email')">
                            <el-input v-model="auth.mediafire.email"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passWord')">
                            <el-input v-model="auth.mediafire.password"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div class="lite_popup_footer">
                <button @click="submit()">
                    <i v-if="auth.loading" class="el-icon-loading" style="color:#fff;"></i>
                    <span>{{ auth.did ? $t('language.leftBanner.edit') : $t('language.common.addCloud') }}</span>
                </button>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    props: {
        auth: Object,
    },
    methods: {
        submit() {
            this.$emit('submit');
        }
    },
    computed: {
        hidePopup() {
            return ['GoogleDrive','OneDrive','Dropbox','Box','PCloud','GoogleWorkspace'].includes(this.auth.type)
        },
    },
    watch: {
        'auth.show'(val) {
            if (val && this.hidePopup) {
                this.$nextTick(() => {
                    this.$emit('submit');
                });
            }
        }
    },
};
</script>

<style>
.lite_popup_box {
  width: 680px;
}

.add_drive .el-form-item__label {
  position: relative;
  top: 10px;
}

.switch-box {
  padding-top: 10px;
}

.el-input__inner:focus {
  border-color: #5166BD;
}
.el-textarea__inner:focus {
  border-color: #5166BD;
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/lite_add_drive.vue